const en = {
	confirmPassword: "Reenter your password correctly",
	min: "Cannot be lower than $constraint1",
	max: "Cannot be higher than $constraint1",
	isNotEmpty: "Cannot be empty",
	minDate: "Minimum date is $constraint1",
	maxDate: "Maximum date $constraint1",
	isEmail: "Must be a valid e-mail",
	minLength: "Must have at least $constraint1 characters",
	maxLength: "Cannot have more than $constraint1 characters",
	get length() {
		return (args: any) => {
			if (!args.value || args.value.length < args.constraints[0]) {
				return this.minLength;
			}
			return "Cannot have more than $constraint2 characters";
		};
	},
	isBrPhone: "Must be a valid Brazilian phone number",
	isCPF: "Must be a valid Brazilian tax document number",
	isUuid: "Invalid file",
	isEnum: "Choose an option",
	isDate: "Must be a valid date",
};

export default en;
